import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = { target: Number, suffix: { type: String, default: "" } }

  connect() {
    this._fired = false
    this._observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this._fired) {
        this._fired = true
        this._animate()
        this._observer.disconnect()
      }
    }, { threshold: 0.3 })
    this._observer.observe(this.element)
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  _animate() {
    const target = this.targetValue
    const duration = 2000
    const start = performance.now()

    const step = (now) => {
      const elapsed = now - start
      const progress = Math.min(elapsed / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 4)
      const current = Math.round(eased * target)
      this.displayTarget.textContent = current + this.suffixValue
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }
}
